<template>
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        Danh sách Level
      </div>
      <div class="card-title">
        <button
          type="button"
          class="font-weight-bold font-size-3 btn btn-success"
          @click="openCreate"
        >
          Thêm mới
        </button>
      </div>
    </div>
    <div class="card-body" v-loading="loading">
      <div class="example mb-10">
        <div class="row">
          <div class="form-group col-md-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text line-height-0 py-0">
                  <span class="svg-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                        ></path>
                        <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                        ></path>
                      </g>
                    </svg>
                  </span>
                </span>
              </div>
              <input
                type="text"
                class="form-control"
                placeholder="Tên level"
                v-model="formSearch.name"
                aria-describedby="basic-addon2"
                @keyup="handleFormSearch"
              >
            </div>
          </div>

          <div class="form-group col-md-3">
            <div class="form-group">
                <el-select
                    v-model="formSearch.category_id"
                    class="w-100"
                    collapse-tags
                    placeholder="Chọn danh mục"
                    @change="handleFormSearch"
                >
                    <el-option
                        v-for="item in categorys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div>
          </div>
        </div>

        <div class="example-preview table-responsive">
          <table class="table table-vertical-center">
            <thead>
              <tr>
                <th>Mã level</th>
                <th>Tên level</th>
                <th>Cấp bậc</th>
                <th>Loại</th>
                <th>Danh mục</th>
                <th>Kinh nghiệm</th>
                <th>Hệ số nhân</th>
                <th>Tiêu chí lên bậc</th>
                <th>Điểm hạ bậc</th>
                <th>Thời gian xét duyệt</th>
                <th style="min-width: 100px">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="data.length > 0" v-for="(item, key) in data" :key="item.id">
                <td>{{ item.code || item.id }}</td>
                <td>{{ item.level }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.type == 1 ? "Chuyên môn" : "Quản trị" }}</td>
                <td>{{ item.category ? item.category.name : '' }}</td>
                <td>{{ item.experience }}</td>
                <td>{{ item.coefficient }}</td>
                <td>{{ item.score }}</td>
                <td>{{ item.demote_score }}</td>
                <td>{{ item.duration_month }} Tháng</td>
                <td>
                  <button
                    type="button"
                    title="Sửa"
                    class="btn btn-sm btn-icon mr-2 btn-outline-info"
                    @click="openEdit(item)"
                  >
                    <i class="fas fa-pen-nib"></i>
                  </button>
                  <button
                    @click="deleteUserLevel(item.id)"
                    href="javascript:"
                    class="btn btn-sm btn-icon btn-outline-danger"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="data.length === 0 && !loading">
                <td colspan="13" class="event-title no-data">Chưa có dữ liệu</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="edu-paginate mx-auto text-center">
        <paginate
            v-model="page"
            :page-count="last_page"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickCallback"
            :prev-text="'Trước'"
            :next-text="'Sau'"
            :container-class="'pagination b-pagination'"
            :pageLinkClass="'page-link'"
            :next-link-class="'next-link-item'"
            :prev-link-class="'prev-link-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-class="'page-item'"
        >
        </paginate>
    </div>

    <el-dialog
      title="Thêm mới Level"
      :visible.sync="dialogCreate"
      width="600px"
      @close="resetCreateForm"
    >
      <ValidationObserver v-slot="{ handleSubmit }" ref="createFormObserver">
        <form @submit.prevent="handleSubmit(saveCreate)">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Danh mục</label>
                <el-select
                  v-model="createForm.category_id"
                  class="w-100"
                  collapse-tags
                  placeholder="Chọn danh mục"
                >
                  <el-option
                    v-for="item in categorys"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Tên level <small class="text-muted">(tối đa 200 ký tự)</small></label>
                <ValidationProvider
                  vid="name"
                  name="Tên level"
                  rules="required|max:200"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="createForm.level"
                    maxlength="200"
                    placeholder="Nhập tên level"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Kinh nghiệm</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="createForm.experience"
                  placeholder="Nhập kinh nghiệm"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Hệ số nhân <small class="text-muted">(&lt;= 10, tối đa 2 số thập phân)</small></label>
                <ValidationProvider
                  vid="coefficient"
                  name="Hệ số nhân"
                  :rules="{ required: false, regex: /^\d+(\.\d{0,2})?$/, max_value: 9.99 }"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    inputmode="decimal"
                    class="form-control"
                    v-model="createForm.coefficient"
                    placeholder="Ví dụ: 1.25"
                    @input="onCreateCoefficientInput"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Tiêu chí lên bậc</label>
                <ValidationProvider
                  vid="score"
                  name="Tiêu chí lên bậc"
                  :rules="{ required: false, regex: /^\d+(\.\d+)?$/, max_value: 500 }"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    inputmode="decimal"
                    class="form-control"
                    v-model="createForm.score"
                    placeholder="Tiêu chí lên bậc"
                    @input="onCreateScoreInput"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Điểm hạ xuống bậc <small class="text-muted">(tối đa 2 số thập phân)</small></label>
                <ValidationProvider
                  vid="demote_score"
                  name="Điểm hạ xuống bậc"
                  :rules="{ required: false, regex: /^\d+(\.\d{0,2})?$/ }"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    inputmode="decimal"
                    class="form-control"
                    v-model="createForm.demote_score"
                    placeholder="Ví dụ: 10.50"
                    @input="onCreateDemoteScoreInput"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Thời gian xét duyệt <small class="text-muted">(&lt;= 12 tháng)</small></label>
                <ValidationProvider
                  vid="duration_month"
                  name="Thời gian xét duyệt"
                  :rules="{ required: false, regex: /^\d+$/, min_value: 0, max_value: 12 }"
                  v-slot="{ errors, classes }"
                >
                  <div class="input-group">
                    <input
                      type="text"
                      inputmode="numeric"
                      class="form-control"
                      v-model="createForm.duration_month"
                      placeholder="Số tháng"
                      @input="onCreateDurationMonthInput"
                      :class="classes"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">tháng</span>
                    </div>
                  </div>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div slot="footer" class="dialog-footer d-flex justify-content-end">
            <el-button @click="dialogCreate = false">Hủy</el-button>
            <el-button type="primary" class="text-white" style="background: #4D44B5" :loading="savingCreate" native-type="submit">Lưu</el-button>
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>

    <el-dialog
      title="Sửa Level"
      :visible.sync="dialogEdit"
      width="600px"
      @close="resetEditForm"
    >
      <ValidationObserver v-slot="{ handleSubmit }" ref="editFormObserver">
        <form @submit.prevent="handleSubmit(saveEdit)">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Mã level</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="editForm.code"
                  disabled
                  placeholder="Mã level"
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Danh mục</label>
                <el-select
                  v-model="editForm.category_id"
                  class="w-100"
                  collapse-tags
                  placeholder="Chọn danh mục"
                >
                  <el-option
                    v-for="item in categorys"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Tên level <small class="text-muted">(tối đa 200 ký tự)</small></label>
                <ValidationProvider
                  vid="edit_name"
                  name="Tên level"
                  rules="required|max:200"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="editForm.level"
                    maxlength="200"
                    placeholder="Nhập tên level"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Kinh nghiệm</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="editForm.experience"
                  placeholder="Nhập kinh nghiệm"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Hệ số nhân <small class="text-muted">(&lt;= 10, tối đa 2 số thập phân)</small></label>
                <ValidationProvider
                  vid="edit_coefficient"
                  name="Hệ số nhân"
                  :rules="{ required: false, regex: /^\d+(\.\d{0,2})?$/, max_value: 9.99 }"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    inputmode="decimal"
                    class="form-control"
                    v-model="editForm.coefficient"
                    placeholder="Ví dụ: 1,25"
                    @input="onEditCoefficientInput"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Tiêu chí lên bậc</label>
                <ValidationProvider
                  vid="edit_score"
                  name="Tiêu chí lên bậc"
                  :rules="{ required: false, regex: /^\d+(\.\d+)?$/, max_value: 500 }"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    inputmode="decimal"
                    class="form-control"
                    v-model="editForm.score"
                    placeholder="Tiêu chí lên bậc"
                    @input="onEditScoreInput"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Điểm hạ xuống bậc <small class="text-muted">(tối đa 2 số thập phân)</small></label>
                <ValidationProvider
                  vid="edit_demote_score"
                  name="Điểm hạ xuống bậc"
                  :rules="{ required: false, regex: /^\d+(\.\d{0,2})?$/ }"
                  v-slot="{ errors, classes }"
                >
                  <input
                    type="text"
                    inputmode="decimal"
                    class="form-control"
                    v-model="editForm.demote_score"
                    placeholder="Ví dụ: 10.50"
                    @input="onEditDemoteScoreInput"
                    :class="classes"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Thời gian xét duyệt <small class="text-muted">(&lt;= 12 tháng)</small></label>
                <ValidationProvider
                  vid="edit_duration_month"
                  name="Thời gian xét duyệt"
                  :rules="{ required: false, regex: /^\d+$/, min_value: 0, max_value: 12 }"
                  v-slot="{ errors, classes }"
                >
                  <div class="input-group">
                    <input
                      type="text"
                      inputmode="numeric"
                      class="form-control"
                      v-model="editForm.duration_month"
                      placeholder="Số tháng"
                      @input="onEditDurationMonthInput"
                      :class="classes"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">tháng</span>
                    </div>
                  </div>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div slot="footer" class="dialog-footer d-flex justify-content-end">
            <el-button @click="dialogEdit = false">Hủy</el-button>
            <el-button type="primary" class="text-white" style="background: #4D44B5" :loading="savingEdit" native-type="submit">Lưu</el-button>
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import "@/assets/sass/custom/custom_event.scss";
import Swal from "sweetalert2";

import {
  GET_USER_LEVEL,
  CREATE_USER_LEVEL,
  UPDATE_USER_LEVEL,
  DELETE_USER_LEVEL,
  GET_USER_LEVEL_ALL
} from "@/core/services/store/level/level.module";
import {GET_USER_LEVEL_CATEGORY} from "../../../core/services/store/level/level.module";

export default {
  name: "UserLevelList",
  data() {
    return {
      formSearch: {
        name: "",
        status: "",
        category_id: "",
        experience: "",
        coefficient: "",
        score: "",
        criteria_2: "",
        criteria_3: "",
        demote_score: "",
        duration_month: "",
      },
      data: [],
      page: 1,
      last_page: 1,
      loading: false,

      dialogCreate: false,
      savingCreate: false,
      createForm: {
        level: "",
        score: "",
        status: 1,
        category_id: "",
        experience: "",
        coefficient: "",
        demote_score: "",
        duration_month: "",
      },

      dialogEdit: false,
      savingEdit: false,
      editForm: {
        id: null,
        code: "",
        level: "",
        status: 1,
        category_id: "",
        experience: "",
        coefficient: "",
        score: "",
        criteria_2: "",
        criteria_3: "",
        demote_score: "",
        duration_month: "",
      },
      categorys: []
    };
  },
  mounted() {
    this.getListUserLevel();
    this.getAllCategory();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản lý Level", route: "user-level-list" },
      { title: "Danh sách Level" },
    ]);
  },
  methods: {
    limitNumber() {
      if (this.createForm.coefficient < 10) {
        this.createForm.coefficient = 9.9;
      }
    },
    getAllCategory()
    {
      this.$store
        .dispatch(GET_USER_LEVEL_CATEGORY, {is_all: true})
        .then((res) => {
          this.categorys = res.data?.data || res.data || [];
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFormSearch() {
      this.page = 1;
      this.getListUserLevel();
    },
    getListUserLevel() {
      this.loading = true;
      const payload = {
        page: this.page,
        name: this.formSearch.name,
        status: this.formSearch.status,
        category_id: this.formSearch.category_id,
        experience: this.formSearch.experience,
        coefficient: this.formSearch.coefficient,
        score: this.formSearch.score,
        criteria_2: this.formSearch.criteria_2,
        criteria_3: this.formSearch.criteria_3,
        demote_score: this.formSearch.demote_score,
        duration_month: this.formSearch.duration_month,
      };

      this.$store
        .dispatch(GET_USER_LEVEL, payload)
        .then((res) => {
          this.data = res.data?.data || res.data || [];
          this.last_page = res?.last_page || res.pagination?.last_page || 1;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clickCallback(page) {
      this.page = page;
      this.getListUserLevel();
    },
    openCreate() {
      this.dialogCreate = true;
      this.resetCreateForm();
    },
    resetCreateForm() {
      this.createForm = {
        name: "",
        score: "",
        status: 1,
        category_id: "",
        experience: "",
        coefficient: "",
        demote_score: "",
        duration_month: "",
      };
      this.savingCreate = false;
    },
    normalizeNumberStr(val) {
      if (val === "" || val === null || val === undefined) return "";
      return String(val).trim().replace(/,/g, ".");
    },
    isAtMostTwoDecimalPlaces(norm) {
      if (norm === "") return true;
      return /^\d+(\.\d{1,2})?$/.test(norm);
    },
    sanitizeDecimalInput(raw, maxDecimals) {
      if (raw == null) return "";
      let s = String(raw).replace(/,/g, ".");
      s = s.replace(/[^\d.]/g, "");
      const parts = s.split(".");
      if (parts.length > 2) {
        s = parts[0] + "." + parts.slice(1).join("");
      }
      const dotIdx = s.indexOf(".");
      if (dotIdx !== -1 && maxDecimals >= 0) {
        s = s.slice(0, dotIdx + 1 + maxDecimals);
      }
      return s;
    },
    onCreateCoefficientInput(e) {
      this.createForm.coefficient = this.sanitizeDecimalInput(e.target.value, 2);
    },
    onCreateScoreInput(e) {
        let value = this.sanitizeDecimalInput(e.target.value, 6);

        if (value !== '' && Number(value) > 500) {
            value = '500';
        }

        this.createForm.score = value;
    },
    onCreateDemoteScoreInput(e) {
      this.createForm.demote_score = this.sanitizeDecimalInput(e.target.value, 2);
    },
    onCreateDurationMonthInput(e) {
      this.createForm.duration_month = String(e.target.value ?? "").replace(/[^\d]/g, "");
    },
    onEditCoefficientInput(e) {
      this.editForm.coefficient = this.sanitizeDecimalInput(e.target.value, 2);
    },
    onEditScoreInput(e) {
      let value = this.sanitizeDecimalInput(e.target.value, 6);

      if (value !== "" && Number(value) > 500) {
        value = "500";
      }

      this.editForm.score = value;
    },
    onEditDemoteScoreInput(e) {
      this.editForm.demote_score = this.sanitizeDecimalInput(e.target.value, 2);
    },
    onEditDurationMonthInput(e) {
      this.editForm.duration_month = String(e.target.value ?? "").replace(/[^\d]/g, "");
    },
    validateCreateForm() {
      const f = this.createForm;
      const name = (f.name || "").trim();
      if (!name) return "Vui lòng nhập tên level";
      if (name.length > 200) return "Tên level tối đa 200 ký tự";

      const coeff = this.normalizeNumberStr(f.coefficient);
      if (coeff !== "") {
        if (!this.isAtMostTwoDecimalPlaces(coeff)) {
          return "Hệ số nhân chỉ được nhập tối đa 2 chữ số sau dấu thập phân";
        }
        const coeffNum = parseFloat(coeff);
        if (Number.isNaN(coeffNum) || coeffNum >= 10) {
          return "Hệ số nhân phải nhỏ hơn 10";
        }
      }

      const score = this.normalizeNumberStr(f.score);
      if (score !== "") {
        const scoreNum = parseFloat(score);
        if (Number.isNaN(scoreNum) || scoreNum >= 500) {
          return "Tiêu chí lên bậc phải nhỏ hơn 500";
        }
      }

      const demote = this.normalizeNumberStr(f.demote_score);
      if (demote !== "") {
        if (!this.isAtMostTwoDecimalPlaces(demote)) {
          return "Điểm hạ xuống bậc chỉ được nhập tối đa 2 chữ số sau dấu thập phân";
        }
        if (Number.isNaN(parseFloat(demote))) {
          return "Điểm hạ xuống bậc không hợp lệ";
        }
      }

      const duration = this.normalizeNumberStr(f.duration_month);
      if (duration !== "") {
        const d = parseFloat(duration);
        if (Number.isNaN(d) || d < 0 || d >= 12) {
          return "Thời gian xét duyệt phải nhỏ hơn 12 tháng";
        }
      }

      return null;
    },
    buildCreatePayload() {
      const f = this.createForm;
      const payload = {
        name: (f.name || "").trim(),
        score: f.score,
        status: f.status,
        category_id: f.category_id,
        experience: f.experience,
        coefficient: f.coefficient,
        demote_score: f.demote_score,
        duration_month: f.duration_month,
      };
      ["coefficient", "score", "demote_score", "duration_month"].forEach((key) => {
        const n = this.normalizeNumberStr(payload[key]);
        if (n !== "") payload[key] = n;
      });
      return payload;
    },
    buildEditPayload() {
      const f = this.editForm;
      const payload = {
        id: f.id,
        code: f.code,
        level: (f.level || "").trim(),
        score: f.score,
        status: f.status,
        category_id: f.category_id,
        experience: f.experience,
        coefficient: f.coefficient,
        demote_score: f.demote_score,
        duration_month: f.duration_month,
        criteria_2: f.criteria_2,
        criteria_3: f.criteria_3,
      };
      ["coefficient", "score", "demote_score", "duration_month"].forEach((key) => {
        const n = this.normalizeNumberStr(payload[key]);
        if (n !== "") payload[key] = n;
      });
      return payload;
    },
    saveCreate() {
      this.savingCreate = true;
      const payload = this.buildCreatePayload();
      this.$store
        .dispatch(CREATE_USER_LEVEL, payload)
        .then(() => {
          this.dialogCreate = false;
          this.$bvToast?.toast?.("Thêm mới thành công", {
            title: "Thêm mới",
            variant: "success",
            solid: true,
          });
          this.getListUserLevel();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.savingCreate = false;
        });
    },
    openEdit(item) {
      this.dialogEdit = true;
        this.editForm = {
            id: item.id,
            code: item.code ?? item.id ?? "",
            level: item.level ?? "",
            status: typeof item.status === "number" ? item.status : (item.status ? 1 : 0),
            category_id: item.category_id ?? "",
            experience: item.experience ?? "",
            coefficient: item.coefficient ?? "",
            score: item.score ?? "",
            criteria_2: item.criteria_2 ?? "",
            criteria_3: item.criteria_3 ?? "",
            demote_score: item.demote_score ?? "",
            duration_month: item.duration_month ?? "",
        };
    },
    resetEditForm() {
      this.editForm = {
        id: null,
        code: "",
        level: "",
        status: 1,
        category_id: "",
        experience: "",
        coefficient: "",
        score: "",
        criteria_2: "",
        criteria_3: "",
        demote_score: "",
        duration_month: "",
      };
      this.savingEdit = false;
    },
    saveEdit() {
      if (!this.editForm?.id) return;

      this.savingEdit = true;
      this.$store
        .dispatch(UPDATE_USER_LEVEL, this.buildEditPayload())
        .then(() => {
          this.dialogEdit = false;
          this.$bvToast?.toast?.("Cập nhật thành công", {
            title: "Sửa",
            variant: "success",
            solid: true,
          });
          this.getListUserLevel();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.savingEdit = false;
        });
    },
    deleteUserLevel(id) {
      Swal.fire({
        title: "Bạn chắc chắn muốn xóa?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Không",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_USER_LEVEL, id)
            .then((res) => {
              if (res.error) {
                this.$bvToast.toast(res.message, {
                  title: "Xóa",
                  variant: "danger",
                  solid: true,
                });
              } else {
                this.$bvToast.toast(res.message, {
                  title: "Xóa",
                  variant: "success",
                  solid: true,
                });
                this.getListUserLevel();
              }
            })
            .catch((err) => {
              this.$bvToast.toast(err?.data?.message || "Có lỗi xảy ra", {
                title: "Xóa",
                variant: "danger",
                solid: true,
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.no-data {
  text-align: center;
}
</style>

